import { Container, FlexColumn, Media, Separator } from "@opensea/ui-kit"
import type React from "react"
import { headerViewFullVariants } from "./hero-header-view-full-variants"

type Props = {
  info: React.ReactNode
  stats: React.ReactNode
  description?: React.ReactNode
  metadataChips: React.ReactNode
  showMetadataChipsOnLarge?: boolean
}

export function HeroHeaderFullLayoutSkeleton({
  info,
  stats,
  description,
  metadataChips,
  showMetadataChipsOnLarge = true,
}: Props) {
  const { container, content } = headerViewFullVariants()
  return (
    <Container className={container()}>
      <div className={content()}>
        <FlexColumn className="min-w-0">
          {info}
          <Media greaterThanOrEqual="lg">
            {showMetadataChipsOnLarge ? metadataChips : null}
            {description}
          </Media>
        </FlexColumn>
        <FlexColumn className="mt-4 min-w-0 md:mt-0">
          <Media lessThan="md">{metadataChips}</Media>

          <Media lessThan="lg">
            <Separator className="my-4" />
          </Media>

          <Media lessThan="lg">{stats}</Media>
          <Media greaterThanOrEqual="lg">
            <div className="mt-6 gap-3">{stats}</div>
          </Media>
        </FlexColumn>
      </div>
    </Container>
  )
}
